<section class="search-section-home">
  <div class="container">
    <div class="search-section-main">
      <div class="sec-one-home-title wrapper">
        <h1 class="static-txt">
          {{ 'HOME.BANNER_HEADING.FIND_ESCORT_GIRLS_IN' | translate }}
          <span>Danmark</span>
        </h1>
        <!-- <div class="scroll-text slide-remove-mobile">
             <h1 [ngStyle]="{ '--value': cityIdx }"></h1>
             </div> -->
      </div>

      <div class="sec-one-inputs">
        <form
          class="search-form"
          [formGroup]="dataForm"
          (ngSubmit)="onSubmit()">
          <div class="sec-home-input-area">
            <button
              type="button"
              [matMenuTriggerFor]="menu"
              class="nested-sec-select"
              #buttonElementSELECT_LOCATION>
              <span>{{
                isSelectedValue
                  ? isSelectedValueName
                  : ('HOME.SEARCH_FILTER.SELECT_LOCATION' | translate)
              }}</span>
              <i class="fa-solid fa-angle-down"></i>
            </button>

            <mat-menu #menu="matMenu" class="mat-menu sec-one-mat">
              <p
                [ngStyle]="{
                  'min-width': buttonElementSELECT_LOCATION.offsetWidth + 'px',
                }">
                {{ 'HOME.SEARCH_FILTER.PICK_REGION' | translate }}
              </p>
              @for (disData of divisions; track disData.id) {
                <button
                  (click)="
                    onSelectBtnDis(
                      disData.name,
                      disData?.slug,
                      $event,
                      'divisions'
                    )
                  "
                  class="divisions parent-btn"
                  type="button"
                  [ngStyle]="{
                    'min-width':
                      buttonElementSELECT_LOCATION.offsetWidth + 'px',
                  }">
                  {{ disData?.name }}
                  @if (isSelectedValue === disData?.slug) {
                    <span>
                      <i class="fas fa-check"></i>
                    </span>
                  }
                </button>
                @for (area of disData?.area; track area.slug) {
                  <div class="child-container">
                    <button
                      (click)="
                        onSelectBtnDis(area.name, area?.slug, $event, 'area')
                      "
                      class="area child-btn"
                      type="button">
                      {{ area.name }}
                      @if (isSelectedValue === area?.slug) {
                        <span>
                          <i class="fas fa-check"></i>
                        </span>
                      }
                    </button>
                    @for (zone of area?.zone; track zone) {
                      <button
                        (click)="
                          onSelectBtnDis(zone.name, zone?.slug, $event, 'zone')
                        "
                        class="zone child-btn"
                        type="button">
                        {{ zone?.name }}
                        @if (isSelectedValue === zone?.slug) {
                          <span>
                            <i class="fas fa-check"></i>
                          </span>
                        }
                      </button>
                    }
                  </div>
                }
              }
            </mat-menu>
          </div>
          <!-- END! sec-home-input-area (location) -->

          <div class="sec-home-input-area">
            <button
              type="button"
              [matMenuTriggerFor]="categoryMenu"
              class="nested-sec-select"
              #buttonElementSELECT_CATEGORY>
              <span>{{
                isSelectedValueCategory
                  ? isSelectedValueCategoryName
                  : ('HOME.SEARCH_FILTER.SELECT_CATEGORY' | translate)
              }}</span>
              <i class="fa-solid fa-angle-down"></i>
            </button>

            <mat-menu #categoryMenu="matMenu" class="mat-menu sec-one-mat">
              <p
                [ngStyle]="{
                  'min-width': buttonElementSELECT_CATEGORY.offsetWidth + 'px',
                }">
                {{ 'HOME.SEARCH_FILTER.PICK_CATEGORY' | translate }}
              </p>
              @for (data of categories; track data.id) {
                <button
                  (click)="onSelectBtnCategory(data.name, data?.slug, $event)"
                  class="divisions"
                  type="button"
                  [ngStyle]="{
                    'min-width':
                      buttonElementSELECT_CATEGORY.offsetWidth + 'px',
                  }">
                  {{ data?.name }}
                  @if (isSelectedValueCategory === data?.slug) {
                    <span>
                      <i class="fas fa-check"></i>
                    </span>
                  }
                </button>
              }
            </mat-menu>
          </div>
          <!-- END! sec-home-input-area (category) -->

          <div class="sec-home-input-area">
            <button
              type="button"
              [matMenuTriggerFor]="typeMenu"
              class="nested-sec-select"
              #buttonElementSELECT_TYPE>
              <span>{{
                isSelectedValueType
                  ? isSelectedValueTypeName
                  : ('HOME.SEARCH_FILTER.SELECT_TYPE' | translate)
              }}</span>
              <i class="fa-solid fa-angle-down"></i>
            </button>

            <mat-menu #typeMenu="matMenu" class="mat-menu sec-one-mat">
              <p
                [ngStyle]="{
                  'min-width': buttonElementSELECT_TYPE.offsetWidth + 'px',
                }">
                {{ 'HOME.SEARCH_FILTER.PICK_TYPE' | translate }}
              </p>
              @for (data of types; track data.id) {
                <button
                  (click)="onSelectBtnType(data.name, data?.slug, $event)"
                  class="divisions"
                  type="button"
                  [ngStyle]="{
                    'min-width': buttonElementSELECT_TYPE.offsetWidth + 'px',
                  }">
                  {{ data?.name }}
                  @if (isSelectedValueType === data?.slug) {
                    <span>
                      <i class="fas fa-check"></i>
                    </span>
                  }
                </button>
              }
            </mat-menu>
          </div>
          <!-- END! sec-home-input-area (type) -->

          <div class="sec-home-input-area">
            <form
              class="search-form-container"
              (click)="onClickSearchArea($event)">
              <input
                #searchInput
                id="searchInput"
                class="tw"
                type="text"
                [placeholder]="'HOME.SEARCH_FILTER.ENTER_KEYWORD' | translate"
                (focus)="handleFocus()"
                [(ngModel)]="searchQuery"
                name="searchTerm"
                autocomplete="off"
                ngModel
                required
                (keydown.enter)="onSearchNavigate()" />
              @if (searchQuery) {
                <mat-icon
                  class="clear-search"
                  (click)="resetSearch()"
                  aria-label="Clear search input"
                  ><i class="fa fa-times" aria-hidden="true"></i
                ></mat-icon>
              }
            </form>
          </div>

          <div class="sec-home-sub-btn">
            <button type="submit">
              {{ 'HOME.SEARCH_FILTER.SEARCH' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
